import { render, staticRenderFns } from "./Jesus.vue?vue&type=template&id=f520b736&scoped=true&"
import script from "./Jesus.vue?vue&type=script&lang=js&"
export * from "./Jesus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f520b736",
  null
  
)

export default component.exports